import type { MembershipDTO } from "../query/me.js";

export type TenantRole = MembershipDTO["role"];

/**
 * Die Rollen aus `docs/tickets/issue-002-multitenant-rbac-auth.md`, so benannt, wie sie
 * jemand nennen würde, der damit arbeitet — im Backend heissen sie weiter CONTROLLER
 * und SERVICE_EDITOR.
 */
export const ROLE_LABELS: Record<TenantRole, { label: string; description: string }> = {
  CONTROLLER: {
    label: "Einlass",
    description: "Tickets scannen und Einlass bestätigen.",
  },
  SUPPORT: {
    label: "Kundenservice",
    description: "Anfragen beantworten, Buchungen einsehen, Kulanz beantragen.",
  },
  SERVICE_EDITOR: {
    label: "Angebotspflege",
    description: "Angebote und Orte anlegen und pflegen.",
  },
  MANAGER: {
    label: "Betriebsleitung",
    description: "Angebote, Freigaben, Einlass und Rollen für Service und Einlass.",
  },
  TENANT_ADMIN: {
    label: "Unternehmensadmin",
    description: "Vollzugriff im Unternehmen, inklusive Team und Abrechnung.",
  },
  PLATFORM_ADMIN: {
    label: "Plattformadmin",
    description: "Unternehmen und Konten plattformweit verwalten.",
  },
};

/** Welche Shell diese Rolle öffnet. */
export function shellForRole(role: TenantRole | null): "customer" | "controller" | "company" {
  if (role === null) {
    return "customer";
  }
  // Der Einlass ist bewusst ein anderer Ort: dunkel, eine Hauptaktion, Vollbild.
  return role === "CONTROLLER" ? "controller" : "company";
}

/**
 * Rechte gruppiert, damit die Liste im Konto-Menü lesbar bleibt. Der Teil vor dem
 * ersten Punkt ist der Bereich.
 */
export function groupPermissions(permissions: readonly string[]): [string, string[]][] {
  const BEREICHE: Record<string, string> = {
    booking: "Buchungen",
    service: "Angebote",
    venue: "Orte",
    ticket: "Anfragen",
    customer: "Kunden",
    adjustment: "Kulanz",
    role: "Rollen",
    billing: "Abrechnung",
    tenant: "Unternehmen",
    platform: "Plattform",
  };
  const gruppen = new Map<string, string[]>();
  for (const permission of [...permissions].sort()) {
    const bereich = BEREICHE[permission.split(".")[0] ?? ""] ?? "Sonstiges";
    gruppen.set(bereich, [...(gruppen.get(bereich) ?? []), permission]);
  }
  return [...gruppen.entries()];
}
